module.exports = __webpack_public_path__ + "static/ts-caa6a94bcc01b3a9c5452dc61f4b7c9c.png";